import { render, staticRenderFns } from "./FiltersApplied.vue?vue&type=template&id=470b0582"
import script from "./FiltersApplied.vue?vue&type=script&lang=js"
export * from "./FiltersApplied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports